import { c as _c } from "react/compiler-runtime";
export default function GroupCreatePrivate(t0) {
  const $ = _c(19);
  const {
    isPrivate,
    setIsPrivate
  } = t0;
  const t1 = `tw-rounded-full tw-bg-gradient-to-b tw-p-[1px]  ${isPrivate ? "tw-from-primary-300" : "tw-from-iron-600"}`;
  let t2;
  if ($[0] !== isPrivate || $[1] !== setIsPrivate) {
    t2 = () => setIsPrivate(!isPrivate);
    $[0] = isPrivate;
    $[1] = setIsPrivate;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isPrivate || $[4] !== t2) {
    t3 = <input id="private-group-toggle" type="checkbox" checked={isPrivate} onChange={t2} className="tw-sr-only" />;
    $[3] = isPrivate;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `tw-p-0 tw-relative tw-flex tw-items-center tw-h-6 tw-w-11 tw-flex-shrink-0 tw-cursor-pointer tw-rounded-full tw-border-2 tw-border-transparent tw-transition-colors tw-duration-200 tw-ease-in-out focus:tw-outline-none ${isPrivate ? "tw-bg-primary-500 focus-focus:tw-ring-2 focus-visible:tw-ring-primary-500 focus-visible:tw-ring-offset-2" : "tw-bg-iron-700"}`;
  const t5 = `tw-pointer-events-none tw-inline-block tw-h-5 tw-w-5 tw-transform tw-rounded-full tw-bg-iron-50 tw-shadow tw-ring-0 tw-transition tw-duration-200 tw-ease-in-out ${isPrivate ? "tw-translate-x-5" : "tw-translate-x-0"}`;
  let t6;
  if ($[6] !== t5) {
    t6 = <span aria-hidden="true" className={t5} />;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isPrivate || $[9] !== t4 || $[10] !== t6) {
    t7 = <span className={t4} role="switch" aria-checked={isPrivate}>{t6}</span>;
    $[8] = isPrivate;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t7) {
    t8 = <div className={t1}>{t3}{t7}</div>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="tw-mb-0 tw-text-sm sm:tw-text-base tw-font-semibold tw-text-iron-50">Private group</span>;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8) {
    t10 = <div><label htmlFor="private-group-toggle" className="tw-flex tw-cursor-pointer"><div className="tw-flex tw-items-center tw-gap-x-2 sm:tw-gap-x-3">{t8}{t9}</div></label></div>;
    $[17] = t8;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}